import { gamificationServiceApi } from '@/services/api';

export interface RegisterDevicePayload {
  token: string;
  platform: 'android' | 'ios' | 'web';
  device_id?: string | null;
}

export interface RegisteredDevice {
  id: string | number;
  user_id: string | number;
  platform: string;
  device_id: string | null;
  is_active: boolean;
  last_registered_at: string;
}

export async function registerNotificationDevice(
  payload: RegisterDevicePayload
): Promise<RegisteredDevice> {
  const response = await gamificationServiceApi.post<{
    success: boolean;
    message?: string;
    data: RegisteredDevice;
  }>(
    '/notifications/register-device',
    payload
  );

  if (!response.success || !response.data?.success) {
    throw new Error(response.error || response.message || 'Failed to register notification device');
  }

  return response.data.data;
}
